/** @format */

import { apiSlice } from "../apiSlice";
import { IsoDateString } from "../../types";
import { UserRole } from "./userApi";

// NOTE: type copied from SAM app so should match
export type userLogInfo = {
  role: UserRole;
  displayName: string;
  avatar: string;
};

// NOTE: type copied from SAM app so should match
export type itemLog = {
  time: IsoDateString;
  user: userLogInfo;
  itemKey: { PK: string; SK: string };
  changes: { summary: string; changes: string };
};

export type LogResponse = {
  logs: itemLog[];
  PK: string;
  SK: string;
};

export const resourceApiSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    /**
     * getResourceLogs query (GET)
     * @param Key and object containg the PK and SK of the item in Base64
     * @returns {LogResponse} the fetched logs
     */
    getResourceLogs: build.query<
      LogResponse,
      { itemPK_B64: string; itemSK_B64: string }
    >({
      query: ({ itemPK_B64, itemSK_B64 }) => `/log/${itemPK_B64}/${itemSK_B64}`,
      transformResponse: (response: { logItem: LogResponse }) =>
        response.logItem,
    }),
  }),
});

export const { useGetResourceLogsQuery } = resourceApiSlice;
